/**
 * Moderation status for city people.
 * Existing rows default to `approved`.
 * `rejected` — human admin. `rejected_mcp` — MCP / automated heuristics.
 */
export enum PersonReviewStatusEnum {
    APPROVED = 'approved',
    NEED_REVIEW = 'needReview',
    REJECTED = 'rejected',
    /** Rejected by MCP / automated heuristics (not human moderator). */
    REJECTED_MCP = 'rejected_mcp',
}
